export default __webpack_public_path__ + "static/mission_black-a71ccb5c3efc0d61bc0806bb1e8af13f.png";